import { render } from "./CurrentOffers.vue?vue&type=template&id=24ccd8da&scoped=true"
import script from "./CurrentOffers.vue?vue&type=script&lang=js"
export * from "./CurrentOffers.vue?vue&type=script&lang=js"

import "./CurrentOffers.vue?vue&type=style&index=0&id=24ccd8da&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ccd8da"]])

export default __exports__